import { getConfigOptional } from '../config';
import type { PageConfig, PagesConfig } from './types';

class PagesRegistry {
  private pages: Map<string, PageConfig> = new Map();
  private initialized = false;

  init(): void {
    if (this.initialized) return;

    const config = getConfigOptional('pages') as PagesConfig | null;
    if (!config?.pages) {
      console.warn('⚠️ PAGES_CONFIG не найден или пуст');
      this.initialized = true;
      return;
    }

    // Сортируем по order, затем по title
    const sorted = [...config.pages].sort((a, b) => {
      if (a.order !== undefined && b.order !== undefined) {
        return a.order - b.order;
      }
      return a.title.localeCompare(b.title);
    });

    for (const page of sorted) {
      this.pages.set(page.id, page);
    }

    this.initialized = true;
    console.log(`✅ Загружено ${this.pages.size} страниц`);
  }

  getAll(): PageConfig[] {
    return Array.from(this.pages.values());
  }

  getById(id: string): PageConfig | undefined {
    return this.pages.get(id);
  }

  async loadContent(pageId: string): Promise<string> {
    const page = this.pages.get(pageId);
    if (!page) {
      throw new Error(`Страница "${pageId}" не найдена`);
    }

    try {
      console.log('loading ', page.url);
      const response = await fetch('/pages/' + page.url);
      console.log('response is ', response);
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      return await response.text();
    } catch (error) {
      console.error(`❌ Ошибка загрузки страницы ${pageId}:`, error);
      throw error;
    }
  }
}

export const pagesRegistry = new PagesRegistry();